import { useOrganizationStore } from '@/store/organization.store'

/**
 * True when the current member's org role is OWNER or ADMIN. Use this to gate
 * UI whose backend endpoints use role-based @Access decorators (which custom
 * permission roles cannot satisfy), so members are not shown actions that 403.
 */
export function useIsOrgAdmin(): boolean {
  const currentOrganization = useOrganizationStore(
    (state) => state.currentOrganization,
  )
  const role = currentOrganization?.userMembership?.role?.toUpperCase()
  return role === 'OWNER' || role === 'ADMIN'
}
